export enum DeviceMetricTileDirection {
    Up = "up",
    Down = "down",
}
